module.exports = __webpack_public_path__ + "static/media/apartment23.0229b05d.jpg";